import React from "react";

const AdditionGroupsList = ({ additionGroups }) => {
    if (!additionGroups || additionGroups.length === 0) return null;

    // ✅ Helper: Build formatted data for display
    const prepareDisplayData = (group) => {
        const freeItemsAllowed = group.numberOfFreeItems || 0;
        const pricePerAddition = parseFloat(group.pricePerAddition || 0);
        let freeLeft = freeItemsAllowed;

        const groupedItems = [];

        // Loop through addition items
        group.additionItems.forEach((item) => {
            let remainingQty = item.quantity;

            // Apply complimentary
            const freeQty = Math.min(remainingQty, freeLeft);
            if (freeQty > 0) {
                groupedItems.push({
                    name: item.additionItemName,
                    qty: freeQty,
                    price: 0
                });
                freeLeft -= freeQty;
                remainingQty -= freeQty;
            }

            // Remaining items are charged
            if (remainingQty > 0) {
                groupedItems.push({
                    name: item.additionItemName,
                    qty: remainingQty,
                    price: pricePerAddition * remainingQty // ✅ FIX applied here
                });
            }
        });

        // ✅ Merge same name+price combos for clean display
        const mergedDisplay = [];
        groupedItems.forEach((it) => {
            const existing = mergedDisplay.find(
                (m) => m.name === it.name && m.price === it.price
            );
            if (existing) {
                existing.qty += it.qty;
            } else {
                mergedDisplay.push({ ...it });
            }
        });

        return mergedDisplay;
    };

    return (
        <div className="mt-2">
            <div className="mt-2 space-y-4 mb-4">
                {additionGroups.map((group, gIndex) => {
                    const displayItems = prepareDisplayData(group);

                    return (
                        <div key={gIndex}>
                            {/* Group Header */}
                            <div className="text-[11px] font-medium text-[#341557]">
                                {group.additionGroupName} (Complimentary - {group.numberOfFreeItems})
                            </div>

                            {/* Display List */}
                            <ul className="list-disc list-inside ml-4 text-[11px] text-[#341557]">
                                {displayItems.map((item, iIndex) => (
                                    <li key={iIndex} className="flex justify-between space-x-2">
                                        <div className="break-words whitespace-normal min-w-0">{item.qty} x {item.name}</div>
                                        <div className="min-w-[60px]">{item.price.toFixed(2)} TK</div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </div>

            {/* Custom List Style */}
            <style>{`
        ul.list-disc li {
          position: relative;
          padding-left: 1.2em;
        }
        ul.list-disc li::before {
          content: "•";
          position: absolute;
          left: 0;
          color: #4b5563; /* Tailwind gray-700 */
        }
      `}</style>
        </div>
    );
};

export default AdditionGroupsList;
